import { Mode, ModeWithoutReadOnly, Type } from "../Form";
import { BaseElement } from "../BaseElement";

type Options = {type: Type,question?: string, answer?: string, renderId?: string, required?: boolean};

export class TextField extends BaseElement {
  required: boolean;
  private _question: string;
  private _answer: string;
  questionErrorMessage = '';
  answerErrorMessage = '';

  constructor(options: Options) {
    const { question, answer, renderId, required, type, } = options;
    super(type, renderId);
    this._question = question ?? '';
    this._answer = answer ?? '';
    this.required = required ?? false;
  }

  validateField(mode: Mode): boolean {
    let errorMessage = '';
    if (mode === Mode.EDIT) {
      const valid = !!this.question;
      if (!valid) {
        errorMessage = 'required';
      }
      this.questionErrorMessage = errorMessage;
      return valid;
    } else if (mode === Mode.FORM) {
      const valid = (this.required && !!this.answer) || !this.required;
      if (!valid) {
        errorMessage = 'required';
      }
      this.answerErrorMessage = errorMessage;
      return valid;
    } else {
      return true;
    }
  }

  public get answer() {
    return this._answer;
  }

  public set answer(answer: string) {
    this.answerErrorMessage = '';
    this._answer = answer;
  }

  public get question() {
    return this._question;
  }

  public set question(question: string) {
    this.questionErrorMessage = '';
    this._question = question;
  }

  getForDB(mode: ModeWithoutReadOnly) {
    const result = {
      type: this.type,
      renderId: this.renderId,
      required: this.required,
      question: this.question,
      answer: this.answer,
    };

    if (mode === Mode.EDIT) {
      result.answer = '';
    }

    return result;
  }
}